/**
 * 完売商品表示フィルター
 * 2026年5月16日 修正版33（ページ遷移対応・URLパラメーター状態保持・ページネーションリンク対応）
 *
 * 変更内容：
 * - 無限スクロール廃止に伴い、ページ遷移をまたいでチェック状態を保持する機能を追加
 * - URLパラメーター「hide_sold_out=true」でチェック状態を管理
 * - ページネーションリンクにhide_sold_outパラメーターを自動付与
 */

// URLパラメーターを取得
function getUrlParam(key) {
  return new URLSearchParams(window.location.search).get(key) === 'true';
}

// URLパラメーターを設定（ページリロードなし）
function setUrlParam(key, value) {
  const url = new URL(window.location.href);
  if (value) {
    url.searchParams.set(key, 'true');
  } else {
    url.searchParams.delete(key);
  }
  window.history.replaceState({}, '', url);
}

// ページネーションリンクにhide_sold_outパラメーターを付与
function updatePaginationLinks() {
  const hideSoldOut = getUrlParam('hide_sold_out');
  document.querySelectorAll('a[href*="page="]').forEach(link => {
    const url = new URL(link.href);
    if (hideSoldOut) {
      url.searchParams.set('hide_sold_out', 'true');
    } else {
      url.searchParams.delete('hide_sold_out');
    }
    link.href = url.toString();
  });
}

// 完売商品の表示・非表示を切り替え
function toggleSoldOutProducts() {
  const checkboxDesktop = document.getElementById('hide-sold-out');
  const checkboxMobile = document.getElementById('hide-sold-out-mobile');

  const hideSoldOut =
    (checkboxDesktop && checkboxDesktop.checked) ||
    (checkboxMobile && checkboxMobile.checked);

  // URLパラメーターを更新
  setUrlParam('hide_sold_out', hideSoldOut);

  // 商品カードの表示・非表示を切り替え
  const productCards = document.querySelectorAll('product-card[data-available]');
  productCards.forEach(card => {
    const isAvailable = card.getAttribute('data-available');
    const colWrapper = card.closest('.col');
    if (!colWrapper) return;
    if (hideSoldOut && isAvailable === 'false') {
      colWrapper.classList.add('sold-out-hidden');
    } else {
      colWrapper.classList.remove('sold-out-hidden');
    }
  });

  // ページネーションリンクを更新
  updatePaginationLinks();
}

// チェックボックスを同期（デスクトップ↔モバイル）
function syncCheckboxes(source, target) {
  if (source && target) {
    target.checked = source.checked;
  }
}

// フィルターの初期化
function initSoldOutFilter() {
  const checkboxDesktop = document.getElementById('hide-sold-out');
  const checkboxMobile = document.getElementById('hide-sold-out-mobile');

  // ページ読み込み時にURLパラメーターを読んで自動チェック＆適用
  if (getUrlParam('hide_sold_out')) {
    if (checkboxDesktop) checkboxDesktop.checked = true;
    if (checkboxMobile) checkboxMobile.checked = true;
    toggleSoldOutProducts();
  }

  // ページネーションリンクを初期化時にも更新
  updatePaginationLinks();

  // デスクトップチェックボックスのイベント
  if (checkboxDesktop) {
    checkboxDesktop.addEventListener('change', () => {
      syncCheckboxes(checkboxDesktop, checkboxMobile);
      toggleSoldOutProducts();
    });
  }

  // モバイルチェックボックスのイベント
  if (checkboxMobile) {
    checkboxMobile.addEventListener('change', () => {
      syncCheckboxes(checkboxMobile, checkboxDesktop);
      toggleSoldOutProducts();
    });
  }
}

// DOMContentLoaded後にproduct-card定義完了を待って初期化
document.addEventListener('DOMContentLoaded', () => {
  if ('customElements' in window) {
    customElements.whenDefined('product-card').then(() => {
      initSoldOutFilter();
    });
  } else {
    initSoldOutFilter();
  }
});
